import { NewPlanStages } from 'components/auto-lob/newPlan/constants';
import { useContext } from 'react';
import { MPosContext } from 'utils/context';
import { isManualFlowEnabled } from '../../utils';
// import { getPlanName } from 'utils/generics';
import {
    SegmentEventNameTypes,
    SegmentEventButtonNames,
    SegmentEventActionTypes,
    SegmentEventActionNames,
} from 'utils/segment/constants';
import { useViewport } from 'utils/responsive';
import { IModelPlans } from '../types';
import PlanDetailsCard from './planDetailsCard';
import * as Styles from './styles';
import sendSegmentEvent from 'utils/segment';

interface IProps {
    plans: IModelPlans[];
}

function SelectPlan({ plans }: IProps) {
    const {
        planDetails,
        setPlanDetails,
        setActiveStage,
        permissions,
        userDetails,
    } = useContext(MPosContext);
    const { isMobile } = useViewport();

    const onSelect = (
        planId: string,
        planName: string,
        premium: number,
        planCategory: string,
        programId: string,
        productCode?: string
    ) => {
        const showManualFlow = isManualFlowEnabled(
            permissions?.purchase_journey,
            planDetails?.showManualFlow
        );
        if (showManualFlow) {
            setActiveStage(NewPlanStages.VEHICLE_DETAILS);
        } else {
            setActiveStage(NewPlanStages.REVIEW_DETAILS);
        }
        setPlanDetails({
            ...planDetails,
            plan: {
                ...planDetails.plan,
                plan_id: planId,
                plan_name: planName,
                purchase_date: new Date().toISOString(),
                premium,
                plan_category: planCategory,
                program_id: programId,
                ...(productCode !== undefined && { product_code: productCode }),
            },
        });
        /**
         * Segment event
         */
        sendSegmentEvent(
            SegmentEventNameTypes.ACTION,
            {
                action_type: SegmentEventActionTypes.TAP_BTN,
                action_name: SegmentEventActionNames.SELECT_PLAN,
                button_name: SegmentEventButtonNames.SELECT_PLAN,
            },
            { userDetails, isMobile }
        );
    };

    return (
        <Styles.Wrapper>
            <Styles.SelectPlanText>Select your plan</Styles.SelectPlanText>
            {plans.map(
                ({
                    plan_id,
                    plan_name,
                    premium,
                    plan_category,
                    program_id,
                    benefits,
                    product_code,
                }) => (
                    <>
                        <PlanDetailsCard
                            planId={plan_id}
                            name={plan_name}
                            benefits={benefits}
                            premium={premium}
                            planCategory={plan_category}
                            programId={program_id}
                            onClick={onSelect}
                            productCode={product_code}
                        />
                    </>
                )
            )}
        </Styles.Wrapper>
    );
}

export default SelectPlan;
